import React, { forwardRef } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import BurpsuiteEnterpriseMappingForm from './BurpsuiteEnterpriseMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function BurpsuiteEnterpriseCredentialsForm(props, ref) {
    const fields = [
    {
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules:[urlRegexValidator],
    }, {
        name: "token",
        label: "Token",
        required: true,
        type: FieldTypes.PASSWORD,
    }];

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={BurpsuiteEnterpriseMappingForm}
        />
    )
}

export default forwardRef(BurpsuiteEnterpriseCredentialsForm);